import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from "react";

import Home from "./pages/home";
import About from "./pages/about";
import Contact from "./pages/contact";
import Error from "./components/error";
import NavBar from "./components/navBar";
import Form from "./components/form";

function App() {
  // const url = "http://localhost:3000/";
  // const [data, setData] = useState([]);

  // const fetchData = async (url) => {
  //   try {
  //     const response = await fetch(url);
  //     const data = await response.json();
  //     setData(data);
  //     console.log(data);
  //   } catch (e) {
  //     console.log("heloooooo" + e.message);
  //   }
  // };
  // useEffect(() => {
  //   fetchData(url);
  // }, []);
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
